import React from 'react';

import {Helmet, useQuery} from 'views/module';

import CreateJob from 'views/scenes/career/job_create/CreateJob';

const JobCreate = (props) => {
  const query = useQuery();
  const prefilledJobResponse = React.useMemo(() => JSON.parse(query.jobData || 'null'), [query.jobData]);

  return (
    <>
      <Helmet>
        <title>Quilt: Create Job</title>
      </Helmet>
      <CreateJob
        key={query.jobData}
        prefilledJobResponse={prefilledJobResponse}
      />
    </>
  );
};

export default JobCreate;
